import React, { useRef, useLayoutEffect, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "@/components/styles";
import { IconClose, IconSearch, IconbtnTopDown, IconbtnTopUp } from "@/components/icon";
import { Input } from "antd";

import bus from "@/utils/bus";

import "./searchBar.less";

const { color } = styles;

const SearchBar = ({
  webviewRef,
  wvItem,
  ready,
  visible,
  setVisible
}: {
  webviewRef: any;
  wvItem: any;
  ready: boolean;
  visible: boolean;
  setVisible: any;
}) => {
  const [searchStr, setSearchStr] = useState("");
  const [activeMatchOrdinal, setActiveMatchOrdinal] = useState(0);
  const [matches, setMatches]: any = useState(0);
  const inputRef: any = useRef(null);

  const handleInputChange = (e: any) => {
    setSearchStr(e.target.value);
    const wv = webviewRef?.current;
    console.log("eeeee", e);
    if (e.target.value) {
      wv?.findInPage(e.target.value);
    } else {
      wv?.stopFindInPage("clearSelection");
      setMatches(0);
      setActiveMatchOrdinal(0);
    }
  };
  const handlePressEnter = (e: any) => {
    const wv = webviewRef?.current;
    console.log("pressEnter", e);
    e.target.value && wv?.findInPage(e.target.value, { forward: true });
  };
  const handleClickPrev = (e: any) => {
    const wv = webviewRef?.current;
    wv?.findInPage(searchStr, { forward: false });
  };
  const handleClickNext = (e: any) => {
    const wv = webviewRef?.current;
    wv?.findInPage(searchStr, { forward: true });
  };

  const handleCancelSearch = (e: any) => {
    setVisible(false);
    webviewRef?.current?.stopFindInPage("clearSelection");
    setMatches(0);
    setActiveMatchOrdinal(0);
    setSearchStr("");
  };
  const openSearch = (e: any) => {
    setVisible(true);
  };
  useEffect(() => {
    visible && inputRef.current?.focus();
  }, [visible]);

  const foundInPgCb = React.useCallback((e: any) => {
    // eslint-disable-next-line no-console
    console.log("dddddddxtl: we found it!!!", e);
    const result = e.result;
    console.log("result");
    setMatches(result?.matches | 0);
    setActiveMatchOrdinal(result?.activeMatchOrdinal | 0);
  }, []); // eslint-disable-line

  useEffect(() => {
    webviewRef?.current?.removeEventListener("found-in-page", foundInPgCb);
    webviewRef?.current?.addEventListener("found-in-page", foundInPgCb);
  }, [webviewRef, foundInPgCb]);

  useEffect(() => {
    // const pathname = location?.pathname || "";
    // const localUrl = new URL(window.location?.href) || "";
    // const pageName = localUrl.searchParams.get("page");
    // if (pathname === "/third_apps" || pageName === "builtin-browser") {
    bus.on(`${wvItem.id}searchCb`, openSearch);
    bus.on(`${wvItem.id}cancelSearchCb`, handleCancelSearch);
    // } else {
    //   bus.off(`${wvItem.id}searchCb`, openSearch);
    //   bus.off(`${wvItem.id}cancelSearchCb`, handleCancelSearch);
    // }
    return () => {
      bus.off(`${wvItem.id}searchCb`, openSearch);
      bus.off(`${wvItem.id}cancelSearchCb`, handleCancelSearch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, webviewRef, location]);

  return (
    <div className={`webview-search-bar ${!visible ? "webview-search-bar-hidden" : ""}`}>
      <Input
        ref={inputRef}
        className="webview-search-bar-input"
        size="large"
        value={searchStr}
        onChange={handleInputChange}
        onPressEnter={handlePressEnter}
        suffix={
          <span>
            {activeMatchOrdinal}/{matches}
          </span>
        }
      />

      <div className="search-bar-suffix">
        <span>|</span>
        <span onClick={handleClickPrev}>{IconbtnTopDown}</span>
        <span onClick={handleClickNext}>{IconbtnTopUp}</span>
        <span onClick={handleCancelSearch}>{IconClose}</span>
      </div>
    </div>
  );
};

export default SearchBar;
